export default {
  common: {
    error: "出现错误",
    reload: "重新加载",
    errorNotification: "我们已收到通知并将尽快修复。如果问题持续存在，请",
    contactUs: "联系我们。",
    language: "语言",
    loading: "加载中...",
    loadingText: "加载",
    save: "保存",
    savedSuccessfully: "保存成功",
    saving: "保存中...",
    cancel: "取消",
    edit: "编辑",
    delete: "删除",
    add: "添加",
    search: "搜索",
    filter: "过滤",
    clear: "清除",
    preview: "预览",
    default: "默认：{{value}}",
    optional: "可选",
    required: "必需",
    noData: "无数据",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "位置",
      cities: "城市", 
      regions: "地区",
      countries: "国家",
      showOnMap: "在地图上显示",
      addLocation: "添加位置"
    },
    welcome: {
      title: "欢迎使用Locations So Super。",
      subtitle: "从导航中选择一个部分开始。"
    }
  },

  // Cities section
  cities: {
    title: "城市",
    resourceSingular: "城市",
    resourcePlural: "城市",
    headings: {
      name: "名称",
      status: "状态",
      locations: "位置", 
      region: "地区",
      country: "国家"
    },
    breadcrumbs: {
      cities: "城市"
    }
  },

  // Countries section  
  countries: {
    title: "国家",
    resourceSingular: "国家", 
    resourcePlural: "国家",
    headings: {
      name: "名称",
      status: "状态",
      locations: "位置",
      cities: "城市",
      regions: "地区"
    },
    breadcrumbs: {
      countries: "国家"
    }
  },

  // Regions section
  regions: {
    title: "地区",
    resourceSingular: "地区",
    resourcePlural: "地区", 
    headings: {
      name: "名称",
      status: "状态",
      locations: "位置",
      cities: "城市",
      country: "国家"
    },
    breadcrumbs: {
      regions: "地区"
    }
  },

  // Map section
  map: {
    title: "地图",
    breadcrumbs: {
      locations: "位置"
    }
  },

  // Import section
  import: {
    title: "CSV导入",
    breadcrumbs: {
      locations: "位置"
    },
    new: {
      title: "通过CSV导入位置",
      description: "下载示例CSV模板以查看所需格式的示例",
      sampleTemplate: "示例CSV模板",
      uploadAndContinue: "上传并继续",
      abortOnError: "出错时中止",
      abortOnErrorHelp: "如果有错误，导入将中止，显示错误且不会导入任何位置。",
      needHelp: "需要导入位置的帮助？"
    },
    show: {
      title: "CSV导入",
      youCanLeavePage: "您可以离开此页面",
      backgroundMessage: "您的导入将在后台继续运行",
      importProgress: "导入进度",
      imported: "已导入",
      suffix: "个位置",
      importLog: "导入日志",
      cancelImport: "取消导入",
      cancelConfirmation: {
        title: "取消导入",
        message: "您确定要取消此导入任务吗？此操作无法撤销。",
        note: "注意：对于正在进行的任务，任务需要完成并将在完成后立即删除。",
        yesCancel: "是，取消导入",
        noContinue: "否，继续导入"
      },
      report: "报告",
      failedLocations: "失败的位置",
      uploadAnother: "上传另一个CSV",
      backToLocations: "返回位置",
      importSucceeded: "导入成功",
      importFailed: "导入失败"
    },
    messages: {
      uploadSuccess: "CSV上传成功",
      uploadError: "无法上传CSV",
      pending: "导入尚未开始",
      inProgress: "导入进行中",
      completed: "导入完成",
      invalidHeader: "需要以下列",
      invalidCsvFile: "无效的CSV文件",
      aborted: "导入中止",
      failed: "导入失败",
      cancelled: "导入已取消"
    },
    errors: {
      csvTooLarge: "CSV文件太大",
      languageNotEnabled: "语言'{{language}}'未在此商店启用。请先在设置>语言中启用它。",
      fieldNotTranslatable: "字段'{{field}}'不可翻译。可翻译字段为：{{fields}}",
      locationError: "位置slug：{{slug}} - {{error}}",
      planLimit: "您已达到位置计划限制"
    }
  },

  // Location form
  location: {
    index: {
      title: "位置",
      addLocation: "添加位置",
      import: "导入",
      noPrioritySet: "未设置优先级",
      published: "已发布",
      draft: "草稿",
      resourceSingular: "位置",
      resourcePlural: "位置",
      headings: {
        name: "名称",
        status: "状态", 
        city: "城市",
        region: "地区",
        country: "国家",
        priority: "优先级"
      }
    },
    form: {
      title: "添加位置",
      editTitle: "编辑位置",
      basicInformation: "基本信息",
      name: "名称",
      namePlaceholder: "例如：Brian的砖块",
      nameHelpDefault: "默认：{{defaultName}}",
      details: "详情",
      description: "描述",
      descriptionPlaceholder: "告诉客户这个位置的特殊之处",
      address: "地址",
      addressPlaceholder: "123主街，城市，国家",
      addressLine1: "地址行1",
      addressLine2: "地址行2",
      postalZipCode: "邮政编码",
      city: "城市",
      stateProvinceRegion: "州/省/地区",
      country: "国家",
      phone: "电话",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "电子邮件", 
      emailPlaceholder: "store@example.com",
      website: "网站",
      websitePlaceholder: "https://www.example.com",
      image: "图片",
      imagePlaceholder: "输入图片URL",
      status: "状态",
      statusActive: "活跃",
      statusInactive: "非活跃",
      statusDraft: "草稿",
      priority: "优先级",
      priorityHelpText: "优先级更高的位置在搜索结果中首先显示",
      findOnMapButton: "在地图上查找"
    },
    validation: {
      addressNotFound: "找不到地址",
      createSuccess: "位置创建成功", 
      updateSuccess: "位置更新成功",
      checkFields: "请检查您的字段",
      findOnMap: "请在保存前在地图上找到您的位置"
    },
    errors: {
      loading: "加载位置时出错"
    },
    actions: {
      save: "保存位置",
      delete: "删除位置",
      preview: "预览"
    },
    customFields: {
      title: "自定义字段",
      noCustomFields: "未配置自定义字段",
      configureFields: "配置字段",
      emptyState: "您还没有配置任何自定义字段。自定义字段允许您添加特定于业务需求的额外信息。"
    },
    openingHours: {
      title: "营业时间",
      checkboxLabel: "此位置有营业和关门时间",
      statusOpen: "营业",
      statusOpen24h: "24小时营业",
      statusClosed: "关门",
      openingTimeLabel: "营业时间",
      closingTimeLabel: "关门时间",
      days: {
        monday: "星期一",
        tuesday: "星期二", 
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",
        sunday: "星期日"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "最近添加",
        recentlyModified: "最近修改"
      },
      filters: {
        status: "状态",
        taggedWith: "标记为",
        locationStatus: "位置状态",
        noTagsToShow: "无标签显示",
        searchPlaceholder: "搜索"
      },
      bulkActions: {
        setPublished: "设为已发布",
        setUnpublished: "设为未发布", 
        setPriority: "设置优先级",
        deleteLocations: "删除位置",
        exportCSV: "导出为CSV"
      },
      appliedFilters: {
        statusIs: "状态为{{status}}",
        taggedWith: "标记为{{tag}}",
        nameIncludes: "名称包含{{search}}"
      },
      modals: {
        deleteTitle: "删除位置",
        deleteMessage: "您确定要删除{{count}}吗？",
        deleteMessageAll: "您确定要删除所有位置吗？",
        prioritiseTitle: "优先化{{count}}个位置",
        prioritiseTitleAll: "优先化所有位置",
        delete: "删除",
        cancel: "取消"
      },
      emptyState: {
        noResultsHeading: "找不到任何{{resourcePlural}}",
        noResultsText: "尝试更改过滤器或搜索词",
        noDataHeading: "添加位置以填充{{resourcePlural}}",
        addLocation: "添加位置",
        importFromCSV: "从CSV导入"
      },
      pagination: {
        label: "第{{page}}页，共{{pages}}页"
      },
      messages: {
        updatedSuccessfully: "更新成功",
        deletedSuccessfully: "删除成功", 
        exportedSuccessfully: "导出成功",
        error: "出现错误"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "页面内容",
    editTemplate: "编辑SEO模板", 
    pageTitle: "标题",
    pageDescription: "描述",
    metaTitle: "标题",
    metaDescription: "描述",
    urlHandle: "URL句柄",
    searchEnginePreview: "搜索引擎列表预览",
    editMeta: "编辑元数据",
    previewMeta: "预览元数据",
    loading: "加载中...",
    editingLocaleHelp: "编辑{{locale}}内容。"
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO模板",
    breadcrumbs: {
      seoTemplates: "SEO模板"
    },
    template: {
      title: "{{templateName}}模板 - {{locale}}",
      discardChanges: "放弃更改"
    },
    form: {
      pageContent: "页面内容",
      searchEnginePreview: "搜索引擎列表预览",
      title: "标题",
      description: "描述",
      pageTitle: "页面标题",
      metaDescription: "元描述",
      editingLocaleHelp: "编辑{{locale}}翻译。空字段将显示来自{{defaultLocale}}的内容。",
      defaultValue: "默认：{{value}}"
    },
    language: {
      label: "语言",
      defaultHelp: "这是您的默认语言",
      editingHelp: "编辑{{locale}}翻译。空字段将显示{{defaultLocale}}内容。"
    },
    banner: {
      multipleLanguagesDisabled: "未启用多语言",
      enableInSettings: "在设置中启用",
      multipleLanguagesInfo: "要管理多语言的SEO模板，请在语言设置中启用国际化。当前仅显示{{locale}}模板。"
    },
    badges: {
      errors: "错误！",
      unsaved: "未保存"
    },
    messages: {
      saveSuccess: "SEO模板保存成功",
      saveError: "无法保存模板",
      error: "错误..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "基本信息",
      name: "名称",
      save: "保存",
      saving: "保存中...",
      cancel: "取消",
      yourLocationsIn: "您在{{name}}中的位置",
      tableHeadings: {
        name: "名称",
        status: "状态",
        city: "城市",
        region: "地区",
        country: "国家"
      },
      resourceName: {
        singular: "{{name}}位置",
        plural: "{{name}}中的位置"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "地图",
      tags: "标签",
      customFields: "自定义字段",
      languages: "语言",
      plan: "计划",
      addTag: "添加标签",
      addField: "添加字段"
    },
    planBadges: {
      trial: "！",
      endsSoon: "即将结束"
    },
    common: {
      loading: "加载中...",
      error: "错误...",
      breadcrumbs: {
        settings: "设置"
      },
      skeleton: {
        customFields: "自定义字段",
        addField: "添加字段",
        name: "名称",
        contentType: "内容类型",
        usedIn: "用于",
        field: "字段",
        fields: "字段"
      },
      messages: {
        savedSuccessfully: "{{setting}}设置保存成功",
        couldntSave: "无法保存{{setting}}设置"
      }
    },
    map: {
      title: "地图",
      messages: {
        savedSuccessfully: "地图设置保存成功",
        couldntSave: "无法保存设置"
      },
      mapboxToken: {
        title: "Mapbox令牌",
        description: "输入您的Mapbox令牌以为您的商店定位器提供支持",
        label: "Mapbox令牌",
        placeholder: "在此输入令牌以继续使用您的地图。",
        placeholderManaged: "在此输入令牌以继续使用您的地图，一旦您用完免费地图加载次数。",
        helpText: "按照我们的说明创建Mapbox密钥，然后将您的密钥粘贴到上面。如果遇到任何问题，请联系我们寻求帮助。",
        linkInstructions: "创建Mapbox密钥的说明",
        linkSupport: "联系我们寻求帮助"
      },
      managedToken: {
        title: "地图加载",
        description: "使用托管令牌，您最多有{{max}}次免费地图加载，之后您将需要创建自己的令牌。"
      },
      appearance: {
        title: "外观",
        description: "更改您地图的视觉效果"
      },
      mapStyle: {
        title: "地图样式",
        options: {
          streets: "街道",
          outdoors: "户外", 
          light: "浅色",
          dark: "深色",
          satellite: "卫星",
          satelliteStreets: "卫星街道",
          navigationDay: "导航日",
          navigationNight: "导航夜"
        }
      },
      searchBehaviour: {
        title: "搜索行为",
        description: "控制访客如何在地图上找到位置。",
        geolocateLabel: "自动估算访客位置并显示附近商店",
        geolocateHelp: "如果地理定位成功，地图将移动到访客附近。如果无法找到估算位置，地图将保持在起始位置。",
        filterBehaviour: {
          title: "过滤器行为",
          all: {
            label: "所有标签",
            help: "位置要在过滤器中显示，必须具有所有选定的标签"
          },
          any: {
            label: "任何标签", 
            help: "位置要在过滤器中显示，可以具有任何选定的标签"
          }
        },
        keepSearchInView: {
          label: "保持搜索标记在视图中",
          help: "当搜索结果出现时，地图将缩小以显示所有匹配的位置"
        },
        distanceUnits: {
          title: "距离单位",
          km: "公里",
          miles: "英里"
        },
        maxResults: {
          label: "最大结果数",
          help: "限制搜索结果中显示的位置数量",
          options: {
            results30: "30个结果"
          }
        },
        maxDistance: {
          label: "最大距离", 
          help: "仅显示距离搜索点此距离内的位置",
          options: {
            unlimited: "无限制"
          }
        },
        showLocationNames: {
          label: "在建议中显示位置名称",
          help: "在搜索建议中显示位置名称"
        },
        sortByPriority: {
          label: "按优先级而不是距离排序",
          help: "强烈建议如果选中此框，设置最大距离（不是无限制）。否则您的客户将看到远离的位置，这些位置具有高优先级，列在距离他们合理距离内的位置之上（或更具体地说，他们的搜索查询）。"
        }
      },
      searchResults: {
        title: "搜索结果",
        description: "控制位置如何在地图上返回。",
        locationsLabel: "搜索结果文本",
        locationsHelp: "搜索结果上方显示的文本（例如，'显示5个位置'）",
        prefixLabel: "搜索结果前缀", 
        prefixHelp: "结果数量前显示的文本"
      },
      popups: {
        title: "弹出窗口",
        showPopups: {
          label: "显示弹出窗口",
          help: "访客点击地图标记时显示位置详情"
        }
             },
       whitelabel: {
         title: "白标",
         hideLabel: "隐藏由...提供文本",
         hideHelp: "从您的商店定位器中移除我们的品牌"
       }
    },
    languages: {
      title: "语言",
      error: "错误...",
      messages: {
        savedSuccessfully: "语言设置保存成功",
        couldntSave: "无法保存语言设置"
      },
      banner: {
        upgradeTitle: "多语言支持需要计划升级",
        upgradeAction: "升级到Superest",
        upgradeMessage: "您仍然可以更改默认语言，但启用多语言需要升级。",
        disabledMessage: "您当前计划中禁用了多语言设置"
      },
      defaultLanguage: {
        title: "默认语言", 
        description: "选择您的内容将显示的主要语言。",
        label: "默认语言",
        help: "当没有请求特定语言时将使用此语言"
      },
      internationalization: {
        title: "国际化",
        description: "启用多语言。接触更多客户并提升您的SEO。",
        enableLabel: "启用多语言",
        enableHelp: "允许客户以不同语言查看您的商店定位器"
      },
      supportedLanguages: {
        title: "其他支持的语言",
        description: "选择您想要支持的其他语言。一旦您启用了语言，您将看到在整个应用程序中提供翻译的选项。对于支持的语言，默认SEO模板以及通用变量主题将自动生成。",
        defaultLocaleNote: "这是您的默认语言，无法禁用",
        shopifyEnabled: {
          label: "此语言在我的Shopify商店中已启用",
          importantNote: "重要：",
          description: "如果此语言未在您的Shopify商店中启用和发布，请取消选中上述框。建议首先在Shopify管理后台的设置 > 语言中为您的Shopify商店启用语言，如果您还没有这样做，以获得更流畅的客户体验。"
        },
        urlFormats: {
          cleanUrls: "干净URL：",
          betterSeo: "更好的SEO和用户体验",
          queryUrls: "查询参数URL：",
          considerEnabling: "考虑在Shopify中启用以获得更好的URL"
        },
        preview: {
          button: "预览",
          tooltip: "预览{{language}}商店定位器"
        },
        tooltips: {
          noTemplates: "此语言没有可用的默认SEO模板。您可以轻松创建自定义翻译。"
        }
      }
    },
    tags: {
      title: "标签",
      addTag: "添加标签",
      error: "错误",
      messages: {
        deletedSuccessfully: "标签删除成功",
        couldntDelete: "标签无法删除",
        savedSuccessfully: "标签保存成功",
        couldntSave: "请检查您的字段",
        tagDeleted: "标签删除成功"
      },
      resourceName: {
        singular: "标签",
        plural: "标签"
      },
      filters: {
        anyGroup: "任何组",
        inGroup: "在组中",
        tagGroup: "标签组"
      },
      appliedFilters: {
        inGroup: "在{{group}}组中",
        nameContains: "标签名称包含{{query}}"
      },
      bulkActions: {
        deleteTag: "删除标签",
        deleteTags: "删除标签"
      },
      form: {
        language: "语言",
        title: "标题",
        description: "描述",
        group: "组",
        groupPlaceholder: "选择组",
        addGroup: "添加",
        editingTranslations: "编辑{{language}}翻译。空字段将显示来自{{defaultLanguage}}的内容。",
        defaultValue: "默认：{{value}}",
        image: "图片",
        imageUrl: "图片URL"
      },
      actions: {
        save: "保存",
        deleteTag: "删除标签"
      },
      new: {
        title: "添加标签",
        messages: {
          createSuccess: "标签创建成功",
          checkFields: "请检查您的字段"
        },
        actions: {
          createTag: "创建标签"
        }
      }
    },
    customFields: {
      title: "自定义字段",
      addField: "添加字段",
      error: "错误",
      resourceName: {
        singular: "字段",
        plural: "字段"
      },
      headings: {
        name: "名称",
        contentType: "内容类型",
        usedIn: "用于"
      },
      emptyState: {
        heading: "创建和管理您的自定义字段",
        createAction: "创建字段",
        description: "使用自定义字段来存储位置的独特属性。这些字段可以是任何内容，从社交媒体资料到商店经理的姓名和电子邮件"
      },
      pluralization: {
        location: "位置",
        locations: "位置"
      },
      form: {
        name: "名称",
        contentType: "内容类型",
        key: "键",
        keyPrefix: "location.fields.",
        keyHelp: "使用此键在您的liquid模板中访问位置的{{name}}内容。",
        translations: {
          title: "翻译",
          showTranslations: "显示翻译",
          hideTranslations: "隐藏翻译",
          description: "翻译是可选的。空字段将显示{{language}}字段名称。",
          nameTranslation: "名称 ({{language}})",
          defaultValue: "默认：{{value}}"
        }
      },
      messages: {
        savedSuccessfully: "字段保存成功",
        couldntSave: "字段无法保存",
        deletedSuccessfully: "字段删除成功",
        couldntDelete: "字段无法删除"
      },
      actions: {
        delete: "删除"
      },
      new: {
        title: "添加字段",
        messages: {
          savedSuccessfully: "字段保存成功",
          couldntSave: "字段无法保存"
        }
      },
      contentTypes: {
        text: "文本",
        textArea: "文本区域", 
        email: "电子邮件",
        number: "数字",
        phoneNumber: "电话号码",
        time: "时间",
        url: "URL"
      }
    },
    plan: {
      title: "计划",
      error: "错误",
      changePlan: "更改计划",
      usdPerMonth: "美元/月",
      sections: {
        yourPlanIncludes: "您的计划包括",
        nextBillingDate: "下次账单日期",
        trial: "试用"
      },
      banners: {
        planUpdated: "您的计划已更新",
        thankYouUpgrading: "感谢您升级！",
        letUsKnow: "让我们知道",
        improvementText: "如果有什么我们可以做得更好的。",
        trialCancellation: {
          title: "试用取消通知",
          message: "一旦您升级到付费计划，您的14天免费试用将被取消。"
        }
      },
      locations: {
        upTo: "最多",
        locations: "个位置",
        unlimited: "无限位置",
        used: "已使用",
        ofUsed: "{{used}} / {{max}} 已使用"
      },
      trial: {
        daysLeft: "剩余{{days}}天",
        daysUsed: "{{used}} / {{total}}天已使用",
        selectPlan: "选择计划",
        currentPlan: "当前计划",
        trialBadge: "试用",
        currentBadge: "当前",
        yourTrialJustStarted: "您的试用刚刚开始",
        trialEndsAfterToday: "您的试用在今天后结束",
        trialEndsTomorrow: "您的试用明天结束",
        daysLeftInTrial: "试用期剩余{{days}}天",
        continueAddingLocations: "通过选择计划在{{date}}后继续添加位置",
        selectPlanToday: "请今天选择计划以继续添加位置"
      },
      footer: {
        description: "管理或更改您的Locations So Super计划。查看我们的",
        termsOfService: "服务条款",
        and: "和",
        privacyPolicy: "隐私政策"
      },
      features: {
        analytics: {
          title: "分析",
          description: "了解人们如何使用您的位置以及他们在哪里搜索"
        },
        internationalization: {
          title: "多语言支持",
          description: "通过启用多种语言来提升SEO并接触目标市场的更多客户"
        },
        customThemes: {
          editLiquid: {
            title: "编辑主题liquid模板",
            description: "通过访问主题liquid以您喜欢的方式显示位置数据"
          },
          editStructuredData: {
            title: "编辑业务结构化数据",
            description: "通过编辑您的结构化数据来编辑Google如何理解页面"
          }
        }
      },
      edit: {
        title: "更改计划",
        allPlansInclude: "以上所有计划包括",
        needingMoreLocations: "需要更多位置？",
        footerQuestion: "开始前有任何问题吗？",
        sendMessage: "给我们发消息",
        allFeatures: {
          seoDirectory: {
            title: "SEO目录和落地页",
            description: "自动创建包含所有位置、城市和地区的SEO目录"
          },
          mapPage: {
            title: "带搜索和过滤的地图页面",
            description: "在地图上搜索和过滤所有位置，地图由mapbox提供支持"
          },
          tags: {
            title: "标签",
            description: "创建带有图像和描述的标签并分组"
          },
          openingHours: {
            title: "营业时间",
            description: "设置并显示您位置的营业时间"
          },
          mapStyles: {
            title: "地图样式",
            description: "使用多种预设样式改变地图外观"
          },
          customFields: {
            title: "自定义字段",
            description: "添加您想要的任何新字段，从社交链接到商店经理"
          },
          csvUpload: {
            title: "使用CSV上传和导出",
            description: "上传并批量编辑您的位置。"
          },
          richSnippets: {
            title: "富摘要",
            description: "通过本地业务结构化数据帮助Google更好地理解页面"
          },
          directionsAndCalls: {
            title: "导航和通话",
            description: "访客可以轻松获取导航并致电位置"
          },
          languageSupport: {
            title: "语言支持",
            description: "将默认语言更改为英语以外的其他语言。提供32种主要语言的翻译模板，便于设置。"
          }
        }
      },
      planCard: {
        bestToCustomize: "最适合定制",
        currentPlan: "当前计划",
        chooseThisPlan: "选择此计划",
        locationsSection: "位置",
        featuresSection: "功能",
        upTo: "最多",
        locations: "位置",
        tooltipTooManyLocations: "您的位置和/或启用的语言数量超过了此计划的限制。"
      },
      confirmation: {
        error: "确认计划时出错"
      }
    }
  },

  // Themes section
  themes: {
    title: "主题",
    currentTheme: {
      title: "当前主题",
      description: "这是客户访问您的位置应用程序时看到的主题。"
    },
    themeLibrary: {
      title: "主题库", 
      description: "管理您的位置主题。添加和发布主题以更改您在线位置的外观。"
    },
    skeleton: {
      currentThemeDescription: "这是您的客户使用位置应用程序时看到的主题。"
    },
    modal: {
      overrideTitle: "覆盖当前主题？",
      override: "覆盖",
      cancel: "取消",
      undoWarning: "此操作无法撤销。"
    },
    messages: {
      publishSuccess: "主题发布成功",
      publishError: "无法发布主题",
      error: "出现错误"
    },
    emptyStates: {
      settings: {
        heading: "此主题没有设置",
        description: "在模板编辑器中创建设置。",
        createSettings: "创建设置",
        upgradePlan: "升级计划",
        upgradeRequired: "升级计划以创建设置"
      },
      language: {
        heading: "此主题没有语言术语",
        description: "在模板编辑器中创建语言术语。",
        createLanguageTerms: "创建语言术语",
        upgradePlan: "升级计划",
        upgradeRequired: "升级计划以创建语言术语"
      }
    },
    templates: {
      categories: {
        templates: "模板",
        schemas: "架构",
        styles: "样式",
        liquidReference: "Liquid参考"
      },
      items: {
        landing: "落地页",
        directory: "目录",
        country: "国家",
        region: "地区",
        city: "城市",
        location: "位置",
        language: "语言",
        settings: "设置",
        stylesheet: "样式表"
      },
      errors: {
        errorsInTemplate: "模板中的错误",
        error: "错误"
      },
      badges: {
        errors: "错误！",
        unsaved: "未保存"
      },
      actions: {
        viewTheme: "查看主题",
        discard: "放弃",
        save: "保存"
      }
    },
    language: {
      messages: {
        saveSuccess: "主题语言翻译保存成功",
        saveError: "主题无法保存"
      },
      form: {
        language: "语言",
        defaultLanguageHelp: "这是您的默认语言",
        translationHelp: "编辑{{selectedLocale}}的翻译。空字段将显示来自{{defaultLocale}}（您的默认语言）的内容。"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "未启用多语言",
          action: "在设置中启用",
          description: "要管理多语言翻译，请在语言设置中启用国际化。当前仅显示{{locale}}翻译。"
        },
        translating: {
          title: "从{{from}}翻译到{{to}}",
          description: "您留空的任何字段将自动向客户显示{{defaultLocale}}内容。仅翻译您希望在{{selectedLocale}}中有不同内容的字段。"
        }
      },
      accessLanguageTerms: "在liquid中使用{{code}}访问{{category}}语言术语",
      fields: {
        // Common language fields - add specific ones as needed
        title: "标题",
        description: "描述",
        heading: "标题",
        subheading: "副标题",
        button_text: "按钮文本",
        link_text: "链接文本",
        placeholder: "占位符",
        label: "标签",
        help_text: "帮助文本",
        error_message: "错误消息",
        success_message: "成功消息",
        
        // Opening hours
        Monday: "星期一",
        Tuesday: "星期二",
        Wednesday: "星期三",
        Thursday: "星期四",
        Friday: "星期五",
        Saturday: "星期六",
        Sunday: "星期日",
        opening_hours_format: "营业时间格式",
        closes_at_format: "关门时间格式",
        opens_at_format: "开门时间格式",
        opens_on: "开门时间",
        open_24h: "24小时营业",
        open: "营业",
        closed: "关门",
        closes_at: "关门时间",
        opens_at: "开门时间",
        
        // Map
        search_map: "搜索地图",
        search_area: "搜索此区域",
        view_map: "地图",
        view_list: "列表",
        open_filters: "过滤器",
        stores_near_you: "您附近的商店",
        header: "查找商店！",
        search_placeholder: "输入邮政编码或地址...",
        no_listings: "抱歉，我们找不到您搜索的任何位置。尝试更改过滤器或搜索位置",
        
        // Directory
        view_directory: "商店目录",
        
        // Location
        get_directions: "导航",
        call: "通话",
        view_website: "网站",
        email: "电子邮件",
        opening_hours_header: "营业时间",
        description_header: "信息",
        phone_number_header: "电话",
        address_header: "地址",
        tag_groups_to_display: "要显示的标签组"
      },
              categories: {
          // Common language categories - add specific ones as needed
          general: "常规",
          navigation: "导航",
          forms: "表单",
          buttons: "按钮",
          messages: "消息",
          errors: "错误",
          opening_hours: "营业时间",
          map: "地图",
          directory: "目录",
          location: "位置"
        }
    },
    settings: {
      messages: {
        saveSuccess: "主题保存成功",
        saveError: "主题无法保存"
      },
      accessSettings: "在liquid中使用{{code}}访问{{category}}设置",
              fields: {
          // Colors
          color_text: "文本颜色",
          color_text_heading: "标题文本颜色", 
          color_background: "背景颜色",
          color_accent: "强调色",
          color_text_positive: "正面文本颜色",
          color_text_negative: "负面文本颜色",
          dark_theme: "深色主题",
          color_marker: "标记颜色",
          color_search_marker: "搜索标记颜色",
        
                  // Typography
          base_font_size: "基础字体大小",
        
                  // Buttons
          border_radius: "边框半径",
        
                  // Images
          aspect_ratio: "宽高比",
          fit: "适应",
        
                  // Spacing
          page_width: "页面宽度",
          page_width_small: "小页面宽度",
          gutter_desktop: "桌面间距",
          gutter_mobile: "移动间距",
          desktop_vertical_spacing: "桌面垂直间距",
          mobile_vertical_spacing: "移动垂直间距",
        
                  // Breakpoints
          breakpoint_xs: "断点XS",
          breakpoint_sm: "断点SM",
          breakpoint_md: "断点MD",
        
                  // Map
          search_on_move: "移动时搜索",
          scroll_to_zoom: "滚动缩放",
        
                  // Landing page
          sidebar_width: "侧边栏宽度",
          sidebar_min_height: "侧边栏最小高度",
          marker_image_src: "标记图片源",
          show_filter_descriptions: "显示过滤器描述",
        
                  // Location page
          tag_groups_to_display: "要显示的标签组",
          tag_groups_to_display_as_icons: "要显示为图标的标签组",
          show_related_locations: "显示相关位置",
        
                  // Locations
          hide_regions: "隐藏地区"
      },
              categories: {
          colors: "颜色",
          typography: "排版",
          buttons: "按钮",
          images: "图片",
          spacing: "间距",
                  breakpoints: "断点",
          map: "地图",
          landing_page: "落地页",
          location_page: "位置页面",
          locations: "位置"
      }
    },
    navigation: {
      sublimeTheme: "Sublime主题",
      settings: "设置",
      language: "语言",
      templates: "模板",
      changeTheme: "更改主题",
      viewDirectory: "查看目录",
      viewLandingPage: "查看落地页"
    },
    card: {
      lastUpdated: "最后更新",
      view: "查看",
      customize: "自定义",
      publish: "发布",
      actions: "操作"
    }
  },

  // Analytics section
  analytics: {
    title: "分析",
    timePeriods: {
      last7days: "最近7天",
      last30days: "最近30天"
    },
    comparison: {
      compareToPrevious: "与上一时期比较",
      stopComparing: "停止与上一时期比较"
    },
    sections: {
      searchLocations: "搜索位置"
    },
    cards: {
      sessions: "会话",
      topSearches: "热门搜索",
      topLandingPageType: "热门落地页类型",
      topPageViewsBySession: "按会话的热门页面浏览量",
      topLocations: "热门位置",
      topReferrers: "热门推荐来源",
      searches: "搜索",
      topLandingPagesBySession: "按会话的热门落地页"
    },
    chartLabels: {
      desktop: "桌面"
    }
  },

}; 